module.exports = __webpack_public_path__ + "93ec41534516a6451bf9bcb2ff50c1da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/state_farm_2023_chart.png
// module id = 1728
// module chunks = 0